import React from 'react';
import TextWithTooltip from '../../../../../../../../../components/TextWithTooltip/TextWithTooltip';

const Item = ({ item, additionalTooltipTitle, parentWidth, ...props }) => {
  return (
    <TextWithTooltip
      {...props}
      parentWidth={parentWidth}
      mainTitle={item.name}
      additionalTitle={additionalTooltipTitle}
      render={({ textRef, ...renderProps }) => (
        <span
          ref={textRef}
          {...renderProps}
        >
          {item.name}
        </span>
      )}
    />
  );
};

export default Item;
